module.exports = __webpack_public_path__ + "images/frontpage_icon@1x.png?12f24471";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_icon@1x.png
// module id = 648
// module chunks = 7